import T from '../i18n/content.js';
import { useT } from '../i18n/LangContext.jsx';

export default function Practice({ asPage = false }) {
  const t = useT();
  const P = T.practice;

  return (
    <section className={`section practice ${asPage ? 'practice--page' : ''}`}>
      <div className="wrap">
        {!asPage && (
          <header className="section__head">
            <div>
              <div className="kicker">
                <span className="label">{t(P.kicker)}</span>
                <span className="bronze-rule" />
              </div>
              <h2>{t(P.pageTitle)}</h2>
            </div>
            <p className="lede">{t(P.lede)}</p>
          </header>
        )}
        <div className="practice-list">
          {T.practices.map(p => (
            <a className="practice-row" key={p.num} id={`practice-${p.num}`} href={`#practice-${p.num}`}>
              <div className="num">{p.num}</div>
              <div className="name">{t(p.name)}</div>
              <div className="desc">
                {t(p.desc)}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
